import React from "react";
import banner from "../../assets/projects/the-cherokee-group.png";
import ss1 from "../../assets/screenshots/aipdfinvoiceparser/ss1.png";
import ss2 from "../../assets/projects/pdfinvoiceparsercherokee.jpg";

const CherokeeInvoiceParserPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">
    {/* Banner Image */}
    <section className="w-full">
      <img
        src={banner}
        alt="The Cherokee Group Invoice Parser Banner"
        className="w-[500px] rounded-xl shadow-md object-cover"
      />
    </section>

    {/* Project Title & Overview */}
    <section>
      <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
        AI-Powered PDF Invoice Parser for The Cherokee Group
      </h1>
      <p className="text-lg text-content lg:max-w-4xl">
      The Cherokee Group, LLC, a leading mechanical and electrical contractor providing plumbing, HVAC, and electrical services to residential and commercial clients, needed a reliable and intelligent way to process daily invoices received via email. With hundreds of invoices coming in every week, manually extracting data was time-consuming and error-prone. To solve this, we developed an AI-powered PDF invoice parser that automatically extracts and structures invoice data from email attachments every morning, allowing their finance team to stay accurate and efficient.
      </p>
    </section>

    {/* Technology Stack */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        💻 Technology Stack
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li><strong>n8n:</strong> Orchestrates the workflow automation and file processing</li>
        <li><strong>Microsoft Outlook:</strong> Fetches and sends emails with attachments</li>
        <li><strong>Microsoft OneDrive:</strong> Stores temporary files securely</li>
        <li><strong>Google Gemini:</strong> Checks and extracts invoice content from PDFs</li>
        <li><strong>OpenAI GPT-4:</strong> Parses and structures extracted text into clean JSON data</li>
      </ul>
    </section>

    {/* Key Features */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        ✨ Key Features
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>AI-based invoice detection and classification</li>
        <li>Reliable file type validation to prevent incorrect data processing</li>
        <li>Fully automated CSV generation with clean and standardized fields</li>
        <li>Secure cloud file storage and email delivery</li>
        <li>Scalable design ready to handle hundreds of invoices daily</li>
      </ul>
    </section>

    {/* AI Automation Flow */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🤖 AI Automation Flow
      </h2>
      <ul className="list-disc list-inside text-content space-y-2">
        <li>Daily or manual trigger initiates the workflow</li>
        <li>Emails fetched from a specific Outlook folder</li>
        <li>Attachments filtered and uploaded to OneDrive with timestamped names</li>
        <li>Only PDF files processed further; non-PDFs are skipped</li>
        <li>Gemini AI verifies if the PDF is an invoice and extracts its raw text and base64 data</li>
        <li>OpenAI model transforms raw text into a structured JSON with fields like vendor name, invoice number, date, and amounts</li>
        <li>CSV file generated and automatically emailed to the finance team</li>
      </ul>
    </section>



    {/* Screenshots */}
    <section>
      <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
        🖼️ Project Images & Screenshots
      </h2>
      <div className="flex flex-col gap-6">
        <div>
          <p className="mb-2 font-medium">Key Features</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Key Features" className="w-full rounded-lg shadow" />
          </a>
        </div>

        <div>
          <p className="mb-2 font-medium">Overall Workflow Overview (n8n)</p>
          <a href={ss1} target="_blank" rel="noopener noreferrer">
            <img src={ss1} alt="Workflow Overview" className="w-full rounded-lg shadow" />
          </a>
        </div>

        {/* <div>
          <p className="mb-2 font-medium">Result</p>
          <a href={ss2} target="_blank" rel="noopener noreferrer">
            <img src={ss2} alt="Result" className="w-full rounded-lg shadow" />
          </a>
        </div> */}
      </div>
    </section>
  </main>
);

export default CherokeeInvoiceParserPage;
